import type { Imputation } from '@mairistem/comptabilite';
import { request } from '@mairistem/tools';
import type { CreateImputation } from '../../utils/imputation';

export const createImputation = (
	identifiantSimulation: number,
	imputation: CreateImputation,
) =>
	request.post<unknown, Imputation>(
		`/api/finances/simulation/${identifiantSimulation}/createImputation`,
		imputation,
	);

export default createImputation;
